export const normalizeKey = (str = '') =>
  str.toString().toLowerCase().replace(/[^a-z0-9]/g, '');
